export default __webpack_public_path__ + "images/family_icon_middle-3402f22b57e9d86622652aab3ba65709.svg";